import api from '../api';
import { ENDPOINTS } from '../../constants/apiEndpoints';

export const fetchAccounts = () => {
  return api.get(ENDPOINTS.account_master.url);
};

export const saveAccountDetails = (accountData) => {
  const requestDTO = {
    data: JSON.stringify(accountData),
    target: 'society.models.master.account.Account',
    compressed: false
  };
  return api.post(ENDPOINTS.account_master.url, requestDTO);
};

export const fetchAccountById = (id) => {
  return api.get(`${ENDPOINTS.account_master.url}/${id}`);
};
